import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EditorComponent, EditorModule} from '@tinymce/tinymce-angular';
import {Helpers} from "../helpers";
import {IBatch} from "./index";
import {BatchQuickEdit, BatchRpcService, QueueRpcService, QuickEditType} from "@alpha/services";

@Component({
  selector: 'note-editor',
  standalone: true,
  imports: [CommonModule, EditorModule, EditorComponent],
  templateUrl: './note-editor.component.html',
  styleUrls: ['./note-editor.component.scss']
})
export class NoteEditorComponent implements AfterViewInit {

  id:string;

  constructor(private bs: BatchRpcService, private qs: QueueRpcService) {
    this.id = Helpers.uuid();
  }

  batch: IBatch | undefined;

  @ViewChild(EditorComponent) editor: EditorComponent | undefined;

  async load(batch: IBatch) {
    this.batch = await this.bs.getLatestBatch(batch.bid);
    this.editor?.editor.setContent(this.batch?.notes ?? "");
  }

   async save() {
    if (this.batch) {
      const quickEditRequest: BatchQuickEdit = {
        batches: [this.batch.bid],
        tags: null,
        order_numbers: null,
        eta: null,
        status: null,
        shipped: null,
        notes: null
      };

      quickEditRequest.editType = QuickEditType.Notes;
      quickEditRequest.notes = this.editor?.editor.getContent();
      await this.qs.queue.enqueue(() => this.bs.processQuickEdit(quickEditRequest));
    }

  }

  ngAfterViewInit() {

  }


}
